import './info-center.css';
import React from "react";

const InfoCenter = () => {
  return (
      <div className="button-enviar">
          <img
              className="texto"
              content="Clean"
              alt="texto"
              src={"/images/Text.svg"}
              width={150}
              height={150.5}/>
          <img
              className="corujito"
              alt="corujito"
              content="Clean"
              src={"/images/corujito.png"}
              width={150}
              height={150.5}/>
      </div>
  );
};
export default InfoCenter;
